import { create } from '@bufbuild/protobuf'
import { useQueryClient } from '@tanstack/react-query'
import { getBalanceQueryKey, BALANCE_QUERY_VARIABLES } from './coin-balance-query'
import { useWorkspaceQuery } from '@repo/studio-hooks-auth/use-workspace-query'
import { GetBalanceResponseSchema } from '../gen/service/creativefabrica/coins/v2/service_pb'
import type { GetBalanceResponse } from '../gen/service/creativefabrica/coins/v2/service_pb'

export function useOptimisticUpdateUserBalance() {
  const queryClient = useQueryClient()
  const { data: workspaceId } = useWorkspaceQuery()
  const queryKey = getBalanceQueryKey(BALANCE_QUERY_VARIABLES, workspaceId)

  function adjustUserBalance(amount: number) {
    if (workspaceId) {
      void queryClient.invalidateQueries({ queryKey })
      return
    }
    const data = queryClient.getQueryData<GetBalanceResponse>(queryKey)
    const next = Number(data?.balance ?? 0) + amount
    if (next < 0) {
      return
    }
    queryClient.setQueryData(
      queryKey,
      create(GetBalanceResponseSchema, {
        balance: BigInt(next),
        teamBalance: data?.teamBalance,
        teamUserBalance: data?.teamUserBalance,
      }),
    )
  }

  function invalidateUserBalanceQuery() {
    setTimeout(() => {
      queryClient.invalidateQueries({ queryKey })
    }, 1500)
  }

  return {
    adjustUserBalance,
    invalidateUserBalanceQuery,
  }
}
